import { render, staticRenderFns } from "./reset-password-form.vue?vue&type=template&id=34e6b279&scoped=true&"
import script from "./reset-password-form.vue?vue&type=script&lang=js&"
export * from "./reset-password-form.vue?vue&type=script&lang=js&"
import style0 from "./reset-password-form.vue?vue&type=style&index=0&id=34e6b279&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e6b279",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CFlex: require('@chakra-ui/vue').CFlex, CBox: require('@chakra-ui/vue').CBox})
